import { call, put } from 'redux-saga/effects';

import {
  receivedResponseOnApplyToFacilitate,
  receivedLatestApplicationEmployer,
  getLatestApplicationEmployerError,
  receivedCorporatePartnersList,
  getCorporatePartnersListError,
 } from "../actions/facilitatorApplication";

import * as applyToFacilitateApi from "../api/facilitatorApplication";

import {
  showErrorMessage,
  showSuccessMessage,
} from "../actions/notification";

export function* applyToFacilitate({ payload }) {
  const { programCode, data } = payload;

  try {
    const res = yield call(applyToFacilitateApi.applyToFacilitate, { programCode, data });
    if (!res?.data?.error?.length) {
      yield put(receivedResponseOnApplyToFacilitate(true));
      yield put(showSuccessMessage('Applying to facilitate club successfully registered'));
    } else {
      yield put(receivedResponseOnApplyToFacilitate(false));
      const msg = res?.data?.error?.length > 5 ? res?.data?.error : 'Error during applying to facilitate';
      yield put(showErrorMessage(msg));
    }

  } catch (e) {
    yield put(receivedResponseOnApplyToFacilitate(false));
    yield put(showErrorMessage('Error during applying to facilitate'));
    // TODO: throw generic error
    console.log('TODO: handle error here');
    console.log(e);
  }
}

export function* getLatestApplicationEmployer() {
  try {
    const { data } = yield call(applyToFacilitateApi.getLatestApplicationEmployer);
    if (data?.error) {
      yield put(getLatestApplicationEmployerError());
    } else {
      yield put(receivedLatestApplicationEmployer(data));
    }

  } catch (e) {
    yield put(getLatestApplicationEmployerError());
    console.log(e);
  }
}

export function* getCorporatePartnersList() {
  try {
    const { data } = yield call(applyToFacilitateApi.getCorporatePartnersList);

    if (data?.error) {
      yield put(getCorporatePartnersListError());
    } else {
      yield put(receivedCorporatePartnersList(data));
    }

  } catch (e) {
    yield put(getCorporatePartnersListError());
    console.log(e);
  }
}
